import { z } from "zod";

import i18n from "@/i18n";

const optionalDate = z.union([
	z.literal(""),
	z.string().regex(/^\d{4}-\d{2}-\d{2}$/, i18n.t("discounts.expiresInvalid")),
]);

export const grantSchema = z.object({
	userId: z
		.string({ required_error: i18n.t("discounts.userIdRequired") })
		.trim()
		.uuid(i18n.t("discounts.userIdInvalid")),
	categoryId: z
		.string({ required_error: i18n.t("discounts.categoryRequired") })
		.min(1, i18n.t("discounts.categoryRequired")),
	expiresAt: optionalDate,
});

export type GrantFormValues = z.infer<typeof grantSchema>;
